"use client";

import { FaCalendarAlt } from "react-icons/fa";
import { FaCalendarDays } from "react-icons/fa6";
import GradientButton from "@/components/shared/html/GradientButton";
import { TransitionLink } from "@/components/shared/TransitionLink";
import { useDict } from "@/components/providers/LocaleProvider";

type NavBookMeetingButtonProps = {
  variant: "compact" | "desktop";
  className?: string;
};

export default function NavBookMeetingButton({
  variant,
  className = "",
}: NavBookMeetingButtonProps) {
  const t = useDict();

  if (variant === "compact") {
    return (
      <TransitionLink href="/book-a-meeting">
        <GradientButton
          hideArrow
          type="button"
          className={`text-white text-xs py-2 gap-x-1 px-4 rounded transition shrink-0 ${className}`}
        >
          {t.nav.bookMeeting}
          <FaCalendarDays aria-hidden />
        </GradientButton>
      </TransitionLink>
    );
  }

  return (
    <TransitionLink
      href="/book-a-meeting"
      className={`cursor-pointer active:scale-95 hover:bg-primary/80 duration-200 gap-2 py-2 flex justify-center items-center rounded-full w-[80px] min-[1328px]:w-[210px] shrink-0 bg-white text-black ${className}`}
    >
      <span className="hidden min-[1328px]:block">{t.nav.bookMeeting}</span>
      <FaCalendarAlt size={17} aria-hidden />
    </TransitionLink>
  );
}
